import"./backdrop-dialog.7d404d5b209a.js";

export class CareQuality {
  constructor() {
    document.addEventListener("click", (e) => {
      if (e.target.closest(".tqc-care-quality")) {
        document.getElementById("care-quality-modal")?.showModal();
      }
    });
  }
}
